import { AutocompleteInput } from 'react-admin';

const AutocompleteInputA = (props: any) => <AutocompleteInput {...props} />;

export default AutocompleteInputA;
